

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';


import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { Close, Key, Person, Repeat } from "@mui/icons-material";


const EditAdmin=({namee})=>{
    
    
    
    
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const {
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:{
        userName:namee?.username,
  
      }});
    
    const changePass=async(data)=>{
        const {newPassword,newPassword2,username}=data
if(newPassword===newPassword2){
    
    const res=await apiService.changePass(data)
    openModalls()
    toast.success('رمز عبور با موفقیت تغییر یافت')
}else{
    toast.error('مقادیر رمز عبور و تکرار آن برابر نیست')
}
    }

    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(changePass)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
              <DriveFileRenameOutlineIcon fontSize="large"/>
            <h4 >   تغییر رمز عبور</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input disabled autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("userName", {
              required: 'این مقدار ضروری است'
            })}/>
            <label for="" className={'labelSS'}><Person fontSize="small"/> نام کاربری  </label>
            {errors?.userName?.message&&<span className='errMsg'> {errors?.userName?.message}  </span>}

        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="password"  className='inputSS' placeholder="a" {...register("newPassword", {
              required: 'این مقدار ضروری است'
            })}/>
            <label for="" className={'labelSS'}><Key fontSize="small"/> رمز عبور </label>
            {errors?.newPassword?.message&&<span className='errMsg'> {errors?.newPassword?.message}  </span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="password"  className='inputSS' placeholder="a" {...register("newPassword2", {
              required: 'این مقدار ضروری است'
            })}/>
            <label for="" className={'labelSS'}><Repeat fontSize="small"/> تکرار رمز عبور </label>
            {errors?.newPassword2?.message&&<span className='errMsg'> {errors?.newPassword2?.message}  </span>}
        </div>
        
        
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default EditAdmin